class StationCoverageZoneSupportStation {
  constructor(priority, stationId, stationCoverageZoneId) {
    this.priority = priority;
    this.stationId = stationId;
    this.stationCoverageZoneId = stationCoverageZoneId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allStationCoverageZoneSupportStations: [],
      stationCoverageZoneSupportStation: new StationCoverageZoneSupportStation(null, null, null),
      allStationCoverageZoneSupportStationsForOther: [],
      stationCoverageZoneSupportStationId: null,
    };
  },
  methods: {
    getAllStationCoverageZoneSupportStations: function (stationCoverageId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAllStationCoverageZoneSupportStations', stationCoverageId)
        .then(() => {
          if (this.$store.state.stationCoverageZoneSupportStationModule.successFlag) {
            this.allStationCoverageZoneSupportStations =
              this.$store.state.stationCoverageZoneSupportStationModule.allStationCoverageZoneSupportStations;
            if (this.load.val) {
              this.load.val = false;
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.stationCoverageZoneSupportStationModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllStationCoverageZoneSupportStations();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.stationCoverageZoneSupportStationModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllStationCoverageZoneSupportStations();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    addStationCoverageZoneSupportStationFunction: function () {
      if (!this.stationCoverageZoneSupportStation.stationId) {
        this.snackText = 'پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.stationCoverageZoneSupportStation.priority) {
        this.snackText = 'اولویت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.stationCoverageZoneSupportStation.stationCoverageZoneId = this.stationCoverageZoneId;
      this.$store
        .dispatch('addStationCoverageZoneSupportStation', this.stationCoverageZoneSupportStation)
        .then(() => {
          if (this.$store.state.stationCoverageZoneSupportStationModule.successFlag) {
            this.$refs.confirm.showConfirmDialog = false;
            this.lakeModal = false;
            this.snackText = 'با موفقیت اضافه شد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            if (this.load.val) {
              this.load.val = false;
            }
            this.stationCoverageZoneSupportStation = new StationCoverageZoneSupportStation(
              null,
              null,
              null,
            );
            this.getAllStationCoverageZones(this.stationId);
          } else {
            this.disabelConfirm = false;
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.stationCoverageZoneSupportStationModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.addStationCoverageZoneSupportStationFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.stationCoverageZoneSupportStationModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.addStationCoverageZoneSupportStationFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    deleteStationCoverageZoneSupportStationFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch(
          'deleteStationCoverageZoneSupportStation',
          this.stationCoverageZoneSupportStationId,
        )
        .then(() => {
          if (this.$store.state.stationCoverageZoneSupportStationModule.successFlag) {
            this.disabelConfirm = false;
            this.$refs.confirm.showConfirmDialog = false;
            if (this.load.val) {
              this.load.val = false;
            }
            this.getAllStationCoverageZoneSupportStations(this.stationCoverageZoneId);
            this.snackText = ' فاقدی با موفقیت حذف شد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
          } else {
            this.disabelConfirm = false;
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.stationCoverageZoneSupportStationModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.deleteStationCoverageZoneSupportStationFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.stationCoverageZoneSupportStationModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.deleteStationCoverageZoneSupportStationFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    cleanLakeForm: function () {
      this.stationCoverageZoneSupportStation = new StationCoverageZoneSupportStation(
        null,
        null,
        null,
      );
    },
    showError: function () {
      this.snackText = this.$store.state.stationCoverageZoneSupportStationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
